import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>About MeowBox Studios</h1>
          <p className="subtitle">A Roblox development studio founded on November 11, 2025</p>
        </div>
      </section>

      <section className="mission-section">
        <div className="container">
          <div className="content-card">
            <h2>Who We Are</h2>
            <p>
              MeowBox Studios is a small, passionate team focused on building polished, atmospheric, 
              and deeply creative experiences on the Roblox platform. We specialize in horror — eerie 
              environments, unsettling creatures, and immersive storytelling — but we also explore other 
              genres that let us experiment, innovate, and create memorable gameplay moments.
            </p>
            <p>
              Our goal is simple: Build unforgettable experiences that players talk about long after 
              they leave the game.
            </p>
          </div>
        </div>
      </section>

      <section className="what-we-do-section">
        <div className="container">
          <h2>What We Do</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h3>Horror Experiences</h3>
              <p>
                We craft tension-heavy worlds inspired by analog horror, backrooms-style surreal spaces, 
                and psychological themes. Our design focuses on immersion, smart AI behavior, and strong 
                visual identity.
              </p>
            </div>
            <div className="feature-card">
              <h3>Creative Gameplay</h3>
              <p>
                Beyond horror, we build unique systems, fun mechanics, and replayable sandbox-style 
                experiences. We want every project to feel distinct, polished, and enjoyable from the 
                moment players join.
              </p>
            </div>
            <div className="feature-card">
              <h3>High-Quality Development</h3>
              <ul className="quality-list">
                <li>Clean, optimized Luau code</li>
                <li>Smooth gameplay and UI</li>
                <li>Strong art direction and worldbuilding</li>
                <li>Secure, server-authoritative systems</li>
                <li>Performance-first design for all devices</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="history-section">
        <div className="container">
          <h2>Our Story</h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3>November 11, 2025 - The Beginning</h3>
                <p>
                  MeowBox Studios was founded by iownrena and rena (pwawli), two passionate Roblox 
                  developers who shared a vision of creating high-quality horror experiences. We formed 
                  a tight, efficient team that handles everything from concept to release.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3>First Projects - In Development</h3>
                <p>
                  We're currently working on our debut games — "Pick up the Phone Horror" and 
                  "Level 974 – MrKitty's Home" (psychological horror). These projects showcase our 
                  commitment to atmospheric horror and immersive storytelling on the Roblox platform.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3>Expanding the Studio</h3>
                <p>
                  We're looking to expand MeowBox with talented creators who share our vision. As we 
                  grow, we're establishing our signature style — games with personality, charm, and a 
                  visual identity that players recognize instantly.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3>Looking Ahead</h3>
                <p>
                  Our plans include building larger and more ambitious worlds, releasing unique horror 
                  titles with deeper lore, and supporting players with consistent updates and quality 
                  improvements. We're committed to becoming a standout name in Roblox horror development.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vision-section">
        <div className="container">
          <div className="content-card">
            <h2>Our Vision</h2>
            <p>
              MeowBox Studios aims to become a standout name in Roblox horror and indie-style development. 
              We want to create games that feel alive — games with personality, charm, and a signature 
              style that players recognize instantly.
            </p>
            <p>
              We're committed to building a positive, welcoming community around our games — one that 
              values creativity, feedback, and collaboration.
            </p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Want to Join Us?</h2>
            <p>
              We're looking for talented creators who share our passion for building atmospheric, 
              polished experiences. Check out our open positions and become part of the team.
            </p>
            <a href="/careers" className="cta-button">View Career Opportunities</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
